/* Florida Plant chat widget. Loaded as an EXTERNAL asset so none of its text
   ("Maya", the greeting, etc.) appears in the page HTML at all — crawlers fetch
   the page, not this file, so the chat content is fully out of crawlable text. */
(function () {
  // ← Replace with your deployed chat server URL
  var API_URL = 'https://content-analysis-production.up.railway.app/api/chat';

  var holder = document.createElement('div');
  holder.innerHTML =
    '<button id="pf-chat-btn" aria-label="Chat with us" data-nosnippet>🌿</button>' +
    '<div id="pf-chat-box" data-nosnippet aria-hidden="true">' +
      '<div id="pf-chat-header"><div class="avatar">🌿</div>' +
      '<div class="info"><div class="name">Maya — Florida Plant</div>' +
      '<div class="status">● Online · Typically replies instantly</div></div>' +
      '<button id="pf-chat-close">×</button></div>' +
      '<div id="pf-chat-messages"><div class="pf-msg bot">Hi! I\'m Maya 🌿 How can I help you today? I can look up your order, answer product questions, or help with anything else!</div></div>' +
      '<div id="pf-chat-input-row"><input id="pf-chat-input" type="text" placeholder="Type a message..." autocomplete="off" />' +
      '<button id="pf-chat-send">➤</button></div>' +
    '</div>';
  while (holder.firstChild) document.body.appendChild(holder.firstChild);

  var btn      = document.getElementById('pf-chat-btn');
  var box      = document.getElementById('pf-chat-box');
  var closeBtn = document.getElementById('pf-chat-close');
  var input    = document.getElementById('pf-chat-input');
  var send     = document.getElementById('pf-chat-send');
  var messages = document.getElementById('pf-chat-messages');
  var history  = [];

  btn.addEventListener('click', function () {
    box.classList.toggle('open');
    if (box.classList.contains('open')) input.focus();
  });
  closeBtn.addEventListener('click', function () { box.classList.remove('open'); });

  function addMsg(text, role) {
    var el = document.createElement('div');
    el.className = 'pf-msg ' + role;
    el.textContent = text;
    messages.appendChild(el);
    messages.scrollTop = messages.scrollHeight;
    return el;
  }

  async function sendMessage() {
    var text = input.value.trim();
    if (!text) return;
    input.value = '';
    addMsg(text, 'user');

    var typing = addMsg('Maya is typing…', 'bot typing');

    try {
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: history }),
      });
      var data = await res.json();
      messages.removeChild(typing);
      addMsg(data.reply || 'Sorry, something went wrong.', 'bot');
      history = data.history || history;
    } catch (e) {
      messages.removeChild(typing);
      addMsg('Sorry, I\'m having trouble connecting. Please email us at onesupplierllc@gmail.com', 'bot');
    }
  }

  send.addEventListener('click', sendMessage);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') sendMessage();
  });
})();
